import { createAsyncThunk } from '@reduxjs/toolkit';
import { multiPortfolioAssetAllocationThunkPayload } from '../../constants';
import container from '@ioc';
import { IAuthenticationService, ILoggingService, MultiPortfolioPerformanceDetails, PortfoliosServiceClient } from 'clientportalshared';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@src/app/config/appConfig';
import { GetPerformanceRequest } from './types';

export const getPerformanceAsync = createAsyncThunk<MultiPortfolioPerformanceDetails, GetPerformanceRequest>(
  multiPortfolioAssetAllocationThunkPayload,
  async (payload: GetPerformanceRequest) => {
    try {
      const authService = container.get<IAuthenticationService>(IAuthenticationService$);
      const loggingService = container.get<ILoggingService>(ILoggingService$);
      const portfoliosClient = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
      return await portfoliosClient.getMultiPortfolioPerformanceAsync(
        payload.compareToBenchmark || null,
        new Date(payload.fromDate),
        new Date(payload.toDate),
        payload.clientPortfolios
      );
    } catch (e) {
      return {} as MultiPortfolioPerformanceDetails;
    }
  }
);
